import customLocalStorage from 'Jsx/Utils/customLocalStorage';

const EVENTS = {
  PAGE_VIEW: 'page_view',
  CLICK: 'click',
  TRAILER: 'trailer',
  RECOMMENDATION_POSITION_CHECKOUT: 'recommendation_position_checkout',
  RECOMMENDATION_POSITION_CLICK: 'recommendation_position_click',
  RECOMMENDATION_VIEW: 'recommendation_view',
  FIRST_PLAY: 'play',
};

type Item =
  | 'course'
  | 'bundle'
  | 'custom_bundle'
  | 'project'
  | 'career'
  | 'membership'
  | 'live'
  | 'ebook'
  | 'tutorial'
  | 'tool'
  | 'blog';

/* eslint-disable camelcase */
type Click = {
  item_id: number;
  item_name: string;
  item_type: Item;
  item_path?: string;
};

type PageView = {
  item_id?: number;
  item_type?: Item;
  value?: number;
  origin_path?: number;
  path?: string;
  /* For mobile only */
  view_name?: string;
};

type Trailer = {
  item_id: number;
  item_name: string;
  hash_id?: string;
  duration: number;
  progress: number;
};

type UpsellRecommendation = {
  item_id?: number;
  item_type: Item;
  /* String created of item ids separated by commas */
  recommendations: string;
  position_selected: number;
  origin: string;
  model_used: string;
};

type RecommendationView = {
  item_id?: number;
  item_type: Item;
  /* String created of item ids separated by commas */
  recommendations: string;
  origin: string;
  model_used: string;
  total_items: number;
};

type Play = {
  product_id: number;
  product_name: string;
  item_type: 'course';
};

const crehanaTrackUrl =
  process.env.NODE_ENV === 'production'
    ? '/api/v3/user-activity/'
    : 'https://qa.creha.co/api/v3/user-activity/';

const userActivity = {
  track(
    eventType,
    customData:
      | Click
      | PageView
      | Trailer
      | UpsellRecommendation
      | RecommendationView
      | Play,
    nextUrl?: string | null,
  ) {
    const userData = customLocalStorage.getItem('creh-tracking-data');

    if (userData) {
      if (process.env.NODE_ENV !== 'production') {
        console.group('------ UserActivity tracking ------');
        console.info(
          'customData: ',
          JSON.stringify({ ...customData, event_type: eventType }),
        );
        console.info('user: ', userData);
        console.groupEnd();
      }
      const parsedUserData = JSON.parse(userData);
      const payload = [
        {
          ...customData,
          app_platform: 'web',
          event_type: eventType,
          ...parsedUserData,
          identifier: `${parsedUserData.username}-${parsedUserData.originalId}`,
          event_date: new Date().toISOString(),
          created_at: new Date().toISOString(),
        },
      ];

      return fetch(crehanaTrackUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(payload),
      })
        .then(res => res.json())
        .then(() => {
          if (nextUrl) {
            location.href = nextUrl;
          } else {
            return { name: 'userActivity', success: true };
          }
        })
        .catch(() => {
          if (nextUrl) {
            location.href = nextUrl;
          } else {
            return { name: 'userActivity', success: false };
          }
        });
    }
    if (nextUrl) {
      location.href = nextUrl;
    }
  },
  EVENTS,
};

export default userActivity;
